export default __webpack_public_path__ + "static/media/Didi.51cbe101.webp";